import styled, { keyframes } from "styled-components";

/* Loading placeholders: the shape of what is coming (the /sites loading's blocks), pulsing softly */
const skeletonPulse = keyframes`
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.25;
  }
`;

/** A block of a screen still loading. Size and shape come from where it is used. */
export const Skeleton = styled.span`
  display: block;
  background:
    linear-gradient(104.66deg, var(--color-neutral-base) -7.77%, var(--color-neutral-dark) 102.05%),
    var(--color-neutral-dark);
  border-radius: 8px;
  animation: ${skeletonPulse} 1.6s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
